import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=9fbb962c&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=9fbb962c&lang=less&scoped=true"
import style1 from "./AdminLayout.vue?vue&type=style&index=1&id=9fbb962c&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fbb962c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fbb962c')) {
      api.createRecord('9fbb962c', component.options)
    } else {
      api.reload('9fbb962c', component.options)
    }
    module.hot.accept("./AdminLayout.vue?vue&type=template&id=9fbb962c&scoped=true", function () {
      api.rerender('9fbb962c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/AdminLayout.vue"
export default component.exports